const formatPriceToPounds = (price: number, shouldUseMonthly = false) =>
  `£${price.toLocaleString()}${shouldUseMonthly ? ' p/m' : ''}`

const getFormattedFromPrice = (
  priceSelection = -1,
  shouldUseMonthly = false,
) => {
  if (priceSelection === -1) return ''
  return `From ${formatPriceToPounds(priceSelection, shouldUseMonthly)}`
}

const getFormattedToPrice = (priceSelection = -1, shouldUseMonthly = false) => {
  if (priceSelection === -1) return ''
  return `Up to ${formatPriceToPounds(priceSelection, shouldUseMonthly)}`
}

export const getFormattedPriceRange = (
  fromPriceSelection = -1,
  toPriceSelection = -1,
  useMonthly = false,
  financeType?: string[],
) => {
  if (fromPriceSelection === -1 && toPriceSelection === -1) return ''
  const shouldUseMonthly = useMonthly || (financeType && financeType.length > 0)

  const fromPrice = getFormattedFromPrice(fromPriceSelection, shouldUseMonthly)
  let toPrice = getFormattedToPrice(toPriceSelection, shouldUseMonthly)

  if (fromPrice) {
    toPrice = ` ${toPrice.replace('Up ', '').toLowerCase()}`
  }

  return `${fromPrice}${toPrice}`.trim()
}
